module.exports = __webpack_public_path__ + "static/media/Slaughered.8e898b96.png";